export default class BookingManagamentService {
  static getBookingManagementUrl(url: string, bookingId: string): string {
    return url.replace(new RegExp('\\${booking.id}', 'gm'), bookingId);
  }
}
